@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-applications-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.applicationContext"
                [application]="_context.applicationContext.item"
                (applicationUpdated)="onApplicationUpdated($event)"
                (canceled)="onCanceled($event)"></app-applications-form>
        </mat-tab>
    </mat-tab-group>
}
